<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="arrow-circle-up-outline"></nb-icon>
        <div class="ml-2" i18n>Promoting Campaign: {{ campaign.id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="clickedCancel()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <!-- This section is visible when user is prompted to promote the campaign -->
    <div *ngIf="!this.service.promotionResponse && !this.service.promotionSpinner && !this.service.promotionError">
      <div class="d-flex" i18n>This Campaign promotion will also promote:</div>
      <br />
      <br />
      <div class="row mb-5">
        <div class="col">
          <div class="field-label" i18n>Insight</div>
          <div class="d-flex align-items-center">
            {{ campaign.trigger_id }}
            <button
              nbButton
              outline
              shape="round"
              size="small"
              status="info"
              class="ml-2"
              (click)="viewInsight(campaign.trigger_id)"
              nbTooltip="View Details"
              i18n-nbTooltip
            >
              <nb-icon icon="search-outline"></nb-icon>
            </button>
          </div>
          <div class="field-label mt-3" i18n>Content</div>
          <div class="d-flex align-items-center">
            {{ campaign.content_id }}
            <button
              nbButton
              outline
              shape="round"
              size="small"
              status="info"
              class="ml-2"
              (click)="viewContent()"
              nbTooltip="View Details"
              i18n-nbTooltip
            >
              <nb-icon icon="search-outline"></nb-icon>
            </button>
          </div>
          <div class="field-label mt-3" i18n>Surveys</div>
          <div class="d-flex align-items-center" *ngFor="let survey of selectedSurveys">
            {{ survey.id }}
            <button
              nbButton
              outline
              shape="round"
              size="small"
              status="info"
              class="ml-2"
              (click)="viewSurvey(survey.id)"
              nbTooltip="View Details"
              i18n-nbTooltip
            >
              <nb-icon icon="search-outline"></nb-icon>
            </button>
          </div>
          <div *ngIf="selectedSurveys?.length === 0">-</div>
        </div>
      </div>
      <div class="d-flex" i18n>Are you sure you want to promote this campaign?</div>
    </div>
    <!-- This section is visible when the response exists from the promotion process request-->
    <div *ngIf="this.service.promotionResponse">
      <div>Campaign has been promoted to the {{ target_environment }}.</div>
      <br />
      <br />
      <div class="row">
        <div class="row mb-5">
          <div class="col">
            <div class="field-label" i18n>Campaign</div>
            <div class="d-flex align-items-center">
              {{ this.service.promotionResponse.campaign_id }}
            </div>
            <div class="field-label mt-3" i18n>Insight</div>
            <div class="d-flex align-items-center">
              {{ this.service.promotionResponse.insight_id }}
            </div>
            <div class="field-label mt-3" i18n>Content</div>
            <div class="d-flex align-items-center">
              {{ this.service.promotionResponse.content_id }}
            </div>
            <div class="field-label mt-3" i18n>Surveys</div>
            <div class="d-flex align-items-center" *ngFor="let response of service.promotionResponse.responses">
              {{ response }}
            </div>
            <div *ngIf="selectedSurveys?.length === 0">-</div>
          </div>
        </div>
      </div>
    </div>
    <!-- This section is visible while the request is pending. -->
    <div *ngIf="this.service.promotionSpinner" i18n>Campaign is getting promoted to {{ target_environment }}.</div>
    <!-- This section is visible when there is an error in the request. -->
    <div *ngIf="this.service.promotionError">
      <div class="row" style="color: red" i18n>Error:</div>
      <br />
      <div class="row">
        {{ this.service.promotionError }}
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer *ngIf="!this.service.promotionError">
    <div class="d-flex justify-content-end">
      <button
        nbButton
        status="danger"
        (click)="clickedCancel()"
        i18n
        [disabled]="service.promotionSpinner || service.promotionResponse"
      >
        No
      </button>
      <button
        nbButton
        class="ml-3"
        status="success"
        (click)="clickedPromote()"
        nbTooltip="Clicking Yes will promote the campaign to the target environment."
        [nbSpinner]="service.promotionSpinner"
        [disabled]="service.promotionSpinner || service.promotionResponse"
        nbSpinnerStatus="info"
        i18n-nbTooltip
        i18n
      >
        Yes
      </button>
    </div>
  </nb-card-footer>
</nb-card>
